export enum DraggableType {
  CheckboxesOptions = 'checkboxesOptions',
  DropdownOptions = 'dropdownOptions',
  RadioButtonsOptions = 'radioButtonsOptions'
}

export type OptionsType = { key: string; value?: string };
